(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('.zuqo-product-columns').forEach(product => {
      if (product.dataset.columnsReady) return;
      const column = product.querySelector('[data-zuqo-details-column]');
      const blocks = [...product.querySelectorAll('[data-zuqo-product-detail]')];
      if (!column || !blocks.length) return;
      product.dataset.columnsReady = 'true';
      const positions = blocks.map(block => {
        const marker = document.createComment('');
        block.before(marker);
        return { block, marker };
      });
      const desktop = window.matchMedia('(min-width: 1100px)');
      const update = () => {
        column.hidden = !desktop.matches;
        product.classList.toggle('zuqo-product-columns--active', desktop.matches);
        positions.forEach(({ block, marker }) => {
          if (desktop.matches) column.append(block);
          else marker.after(block);
        });
      };
      desktop.addEventListener('change', update);
      update();
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(product)) desktop.removeEventListener('change', update);
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
